
export default {
  name: 'AuthWidget',
  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  data() {
    return {
      popupVariants: {
        login: 'AccountLogin',
        create: 'AccountSignUp',
        forgot: 'AccountForgotPassword',
        resetPassword: 'AccountResetPassword',
      },
    };
  },
  computed: {
    widgetContent() {
      return this.popupVariants[this.type];
    },
  },
};
